import {
  EnvironmentVariablesForSiteDocument,
  AllEnvironmentVariablesForSiteDocument,
} from "@modules/site/envVars/queries.generated"
import { useSetSiteCmsIntegrationMutation } from "@modules/cms/shared/queries.generated"
import { useGenericError } from "@modules/modal"
import { useShowSuccessToast } from "gatsby-interface"
import { cmsIntegration as cmsIntegrationText } from "@modules/locales/default.js"

export function useSetCmsIntegration({ siteId }: { siteId: string }) {
  const throwError = useGenericError()
  const showSuccessToast = useShowSuccessToast()
  const [mutate, info] = useSetSiteCmsIntegrationMutation({
    refetchQueries: [
      `cmsIntegrationsForSite`,
      `cmsIntegrationForProvisioning`,
      `activeCmsIntegrationsForSite`,
      {
        query: EnvironmentVariablesForSiteDocument,
        variables: { id: siteId },
      },
      {
        query: AllEnvironmentVariablesForSiteDocument,
        variables: { id: siteId },
      },
    ],
  })

  const setCmsIntegration = async (...args: Parameters<typeof mutate>) => {
    return mutate(...args)
      .then(() => {
        showSuccessToast(cmsIntegrationText.messages.integrationUpdated)
      })
      .catch(err => {
        throwError({ message: err.message })
      })
  }

  return [setCmsIntegration, info] as const
}
